import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { array, bool, string, object, number } from "prop-types";

import { getHeadline, checkCurrentStoryTagForSpecialCampaign } from "../../utils/utils";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import SectionHolder from "../../atoms/SectionHolder";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import SponsorDetails from "../SponsorDetails";

import "./leftImageRightNews.m.css";

const LeftImageRightNews = ({
  story,
  showHeroImage = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  darkTheme = false,
  largeIcon = false,
  sectionData,
  showSectionTag,
  datatrackinglabelpos,
  selectedTagName = "",
  headlineSpecialColor = "",
}) => {
  const { subheadline } = story;
  const storyHeadline = getHeadline(story);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";
  const currentStoryTitleColor = checkCurrentStoryTagForSpecialCampaign(story, selectedTagName, headlineSpecialColor);
  return (
    <div styleName="news_item" className="left_image_right_news">
      <div styleName="left_img">
        {showHeroImage && (
          <Link href={story.url}>
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={widths}
              showAlternateImage={true}
              darkTheme={darkTheme}
              largeIcon={largeIcon}
              datatrackingcategory="Component One"
              datatrackingaction="Click"
              datatrackinglabel={`Position-${datatrackinglabelpos}`}
              datatrackingsubcategory="Component One Story Click"
            />
          </Link>
        )}
      </div>
      <div>
        {showLiveBlog ? (
          <LiveNewsHeadline
            titleText={storyHeadline}
            titleLink={story.url}
            story={story}
            cssStyleName="mediumSize"
            datatrackingcategory="Component One"
            datatrackingaction="Click"
            datatrackinglabel={`Position-${datatrackinglabelpos}`}
            datatrackingsubcategory="Component One Story Click"
          />
        ) : (
          <NewsHeadline
            story={story}
            titleText={storyHeadline}
            titleLink={story.url}
            subHeadlineText={subheadline}
            cssStyleName="mediumSize"
            datatrackingcategory="Component One"
            datatrackingaction="Click"
            datatrackinglabel={`Position-${datatrackinglabelpos}`}
            datatrackingsubcategory="Component One Story Click"
            currentStoryTitleColor={currentStoryTitleColor}
          />
        )}
        {sponsorId ? (
          <SponsorDetails sponsorId={sponsorId} showImage={false} />
        ) : sectionData ? (
          <SectionHolder sectionData={sectionData} story={story} showSectionTag={showSectionTag} />
        ) : null}
      </div>
    </div>
  );
};

LeftImageRightNews.propTypes = {
  story: object.isRequired,
  showHeroImage: bool,
  aspectRatio: array,
  imageType: string,
  widths: array,
  darkTheme: bool,
  largeIcon: bool,
  sectionData: object,
  showSectionTag: bool,
  datatrackinglabelpos: number,
  selectedTagName: string,
  headlineSpecialColor: string,
};

export default LeftImageRightNews;
